// extracted by mini-css-extract-plugin
export default {"fullWidth":"qp-z","image":"rp-z","lazyLoadPicture":"sp-z","lazyLoadSpinner":"tp-z","lazyLoadSpin":"up-z","lazyLoadImage":"vp-z","hasStyledAspectRatio":"wp-z"};